import $             from 'jquery';
import React         from 'react';
import ReactDOM      from 'react-dom';
import Reflux        from 'reflux';
import Modal         from 'react-modal';
import EmailForm     from './form';
import ErrorMessages from './error-messages';
import store         from './store';
import actions       from './actions';
import Utils         from 'medscape/utils';

export default class EmailModal extends Reflux.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.store = store;
  }
  getInitialState() {
    return {
      modalIsOpen: false
    };
  }
  componentDidMount() { }
  componentDidUpdate() {
    $(document).trigger('lockScroll',[this.state.modalIsOpen,"email-modal"]);
  }
  onAfterOpen() { }
  render() {
    let contentTitle = document.querySelector('meta[property="og:title"]').getAttribute('content');
    let subject = `${this.props.senderName} sent you a link to ${contentTitle}`;
    let linkUrl = document.querySelector('meta[property="og:url"]').getAttribute('content');
    let emailProps = {
      contentTitle: contentTitle,
      subject: subject,
      linkUrl: linkUrl
    }
    let emailFormProps = $.extend({}, this.props, emailProps);
    const customStyles = {
      content : {
        top: 20
      },
      overlay:{
        //position: 'absolute',
        //height: $document.height()
      }
    };
    let modalProps = {
      isOpen: this.state.modalIsOpen,
      onAfterOpen: this.onAfterOpen,
      onRequestClose: actions.close,
      shouldCloseOnOverlayClick: false,
      className: "email-modal",
      contentLabel: "Email Modal",
      style: customStyles
    }
    return (
      <Modal {...modalProps}>
        <div className="modal-content-container">
          <div className="header-container">
            <h4 className="modal-title">Email This</h4>
            <div className="close-button-container">
              <a className="close-button" onClick={actions.close}>
                <svg className="close-icon" x="0px" y="0px" viewBox="0 0 96 96" enableBackground="new 0 0 96 96">
                  <polygon className="icon-symbol" points="96,14 82,0 48,34 14,0 0,14 34,48 0,82 14,96 48,62 82,96 96,82 62,48 "/>
                </svg>
              </a>
            </div>
          </div>
          <div className="email-form-container">
            <ErrorMessages />
            <EmailForm {...emailFormProps} />
          </div>
        </div>
      </Modal>
    );
  } // render
}
EmailModal.propTypes={
  contentTitle: React.PropTypes.string,
  subject: React.PropTypes.string,
  linkUrl: React.PropTypes.string,
  senderName: React.PropTypes.string,
  senderEmail: React.PropTypes.string,
  lockScroll: React.PropTypes.func,
  unlockScroll: React.PropTypes.func
};
EmailModal.defaultProps={
  contentTitle: "",
  subject: "",
  linkUrl: "",
  senderName: "",
  senderEmail: ""
};



// WEBPACK FOOTER //
// ./medscape_modules/email-modal/app.jsx